import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

export default function PhotoGrid({ slots }) {
  const [lightboxSrc, setLightboxSrc] = useState(null)

  useEffect(() => {
    if (!lightboxSrc) return
    document.body.style.overflow = 'hidden'
    const onKeyDown = (e) => { if (e.key === 'Escape') setLightboxSrc(null) }
    window.addEventListener('keydown', onKeyDown)
    return () => {
      document.body.style.overflow = ''
      window.removeEventListener('keydown', onKeyDown)
    }
  }, [lightboxSrc])

  return (
    <>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {slots.map(({ src, caption, to }, i) => {
          const content = (
            <>
              {src ? (
                <img src={src} alt={caption || ''} className="absolute inset-0 w-full h-full object-cover" />
              ) : (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14M14 8h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              )}
              {src && (
                <span className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-200 flex items-end justify-center pb-3">
                  {caption && (
                    <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-black/60 text-white text-xs font-semibold px-3 py-1.5 rounded-full">
                      {caption}
                    </span>
                  )}
                </span>
              )}
              {!src && caption && <span className="text-xs text-center text-gray-400">{caption}</span>}
            </>
          )

          const className =
            'group relative aspect-square rounded-xl overflow-hidden bg-ecbc-gray border border-gray-200 flex flex-col items-center justify-center gap-2 text-gray-400 p-3 focus:outline-none'

          if (to) {
            return (
              <Link key={i} to={to} className={className}>
                {content}
              </Link>
            )
          }

          if (src) {
            return (
              <button key={i} type="button" onClick={() => setLightboxSrc(src)} className={`${className} cursor-zoom-in`}>
                {content}
              </button>
            )
          }

          return (
            <div key={i} className={className}>
              {content}
            </div>
          )
        })}
      </div>

      {lightboxSrc && (
        <div
          className="fixed inset-0 z-[100] bg-black/80 flex items-center justify-center p-4 cursor-zoom-out"
          onClick={() => setLightboxSrc(null)}
        >
          <button
            type="button"
            onClick={() => setLightboxSrc(null)}
            aria-label="Close"
            className="absolute top-5 right-5 text-white/80 hover:text-white text-4xl leading-none"
          >
            &times;
          </button>
          <img
            src={lightboxSrc}
            alt=""
            className="max-w-[92vw] max-h-[92vh] object-contain rounded-lg shadow-2xl"
          />
        </div>
      )}
    </>
  )
}
